import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../axios-orders";
import { queryKeys } from "./queryKeys";
import { CATEGORY_ASSIGNMENT_QUERY_KEYS } from "./useAISupplierProfile";

const onGetUserMaterialCategories = async () => {
  const { data } = await axios.get(`/userMaterialCategory/material/category`);
  return data;
};

export const useUserMaterialCategories = () =>
  useQuery({
    queryKey: [queryKeys.USER_MATERIAL_CATEGORIES],
    queryFn: onGetUserMaterialCategories,
  });

// Removes a category from the CURRENT seller by its categoryId. Uses the @CurrentUser-scoped
// ai-profile endpoint (which resolves the assignment row itself) — the old `/userMaterialCategory/{id}`
// path expected the assignment ROW id, not the categoryId the caller has, and 400'd.
const onRemoveUserMaterialCategory = async (categoryId: string) => {
  const { data } = await axios.delete(
    `/api/supplier/ai-profile/categories/${categoryId}`
  );
  return data;
};

export const useRemoveUserMaterialCategory = (
  onSuccess?: (data: any) => void,
  onError?: (error: any) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: onRemoveUserMaterialCategory,
    onSuccess: (data) => {
      // Also refresh the SUPPLIER_ASSIGNED_CATEGORIES list the widget actually renders and the
      // opportunity dashboard — previously only USER_MATERIAL_CATEGORIES was invalidated, so a
      // removed row lingered in the list until a manual refresh.
      CATEGORY_ASSIGNMENT_QUERY_KEYS.forEach((key) =>
        queryClient.invalidateQueries({ queryKey: [key] })
      );
      onSuccess?.(data);
    },
    onError,
  });
};
